import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import Menu from '../../components/sturtural/Menu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import Loader from '../../components/sturtural/Loader';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { addLocale } from 'primereact/api';
import { storage } from '../../helpers/storage';

const estatues = [
    { label: 'Todos', value: 0 },
    { label: 'Pendientes', value: 1 },
    { label: 'Entregados', value: 2 },
    ]

const ReporteCorteAdministrador = () => {
    const navigate = useNavigate();

    const [tiendas, setTiendas] = useState(null);
    const [loading_tiendas, setLoading_tiendas] = useState(false);
    const [error_tiendass, setErrors_tiendas] = useState(false);
    const [tienda, setTienda] = useState();

    const [calendarValueInicio, setCalendarValueInicio] = useState(null);
    const [calendarValueFin, setCalendarValueFin] = useState(null);

    const [loading, setLoading] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);

    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo');
    const [estatus, setEstatus] = useState(estatues[0].value);
    

    useEffect(() => {
        if (![1, 5, 3, 19, 20, 21].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    let url = `${BASE_API}Entrega/GetObtenerGrupoTiendas`;
    useEffect(() => {
        setLoading_tiendas(true);
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            let response = res;
            if (response.SUCCESS === true) {
                setTiendas(response.ITEMS);
                setErrors_tiendas(false);
            } else {
                setTiendas(null);
                setErrors_tiendas('Error en la extracción de datos de REGIONALES');
            }
            setLoading_tiendas(false);
        });
    }, [url]);

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const handleSubmit_busqueda = () => {

        if (tienda !== undefined) {
            setLoading(true);
            helpHttp().post(`${BASE_API}Reportes/spdReportes`, {
                body: {
                    Opcion: 5,
                    parametrosExtra: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar},"IdTienda": ${tienda.code},"IdEstatus": ${estatus}, "fechaIni": ${(calendarValueInicio === null || calendarValueInicio === undefined ? '1900' : `"${calendarValueInicio.toISOString()}"`)},"fechaFin": ${(calendarValueFin === null || calendarValueFin === undefined ? '3000' : `"${calendarValueFin.toISOString()}"`)}}]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    let excel = res.ITEMS;

                    let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                    const date = new Date();
                    let download = document.createElement('a');
                    download.href = temp;
                    download.download = `Bitacora_Diaria_De_Cambios_${formatDate(date)}.xlsx`;
                    document.body.appendChild(download);
                    download.click();
                    document.body.removeChild(download);

                    setLoading(false);
                } else {
                    setMessage(res.MESSAGE);
                    setAviso(true);

                    setLoading(false);
                }
            });
        } else {
            setMessage('Debe seleccionar una sede.');
            setAviso(true);
        }

    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const handlerRedirect = () => {
        setAviso(false);
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button" />;

    return (
        <>
            <Menu link='reporte-general' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h3>Bitácora diaria de canjes</h3>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-3">
                                <label htmlFor="regional">{loading_tiendas && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Sede:</label>
                                {error_tiendass !== false
                                    ?
                                    error_tiendass
                                    :
                                    <Dropdown id="tienda" name="tienda" value={tienda} filter options={tiendas} onChange={(e) => setTienda(e.target.value)} optionLabel="name" placeholder="Elige una sede" className=""></Dropdown>
                                }

                            </div>
                            <div className="field col-12 md:col-3">
                                <label htmlFor="regional">Estatus:</label>
                                <Dropdown id="estatus" name="estatus" value={estatus} options={estatues} onChange={(e) => setEstatus(e.target.value)} optionLabel="label" optionValue='value' placeholder="Elige un estatus" />
                            </div>
                            <div className="field col-12 md:col-3">
                                <label htmlFor="regional">Fecha inicio:</label>
                                <Calendar locale='es' dateFormat='dd/mm/yy' showIcon showButtonBar value={calendarValueInicio} onChange={(e) => setCalendarValueInicio(e.value)}></Calendar>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label htmlFor="nivel">Fecha fin:</label>
                                <Calendar dateFormat='dd/mm/yy' locale='es' showIcon showButtonBar value={calendarValueFin} onChange={(e) => setCalendarValueFin(e.value)}></Calendar>
                            </div>
                        </div>
                        <div className="p-dialog-footer">
                            <div className=" border-top-1 surface-border pt-3 text-right">
                                <Button
                                    type='button'
                                    name="button-generar"
                                    id="button-generar"
                                    disabled={loading}
                                    icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')}
                                    label="Generar"
                                    onClick={() => handleSubmit_busqueda()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog header="Aviso" visible={aviso} onHide={() => setMessage(false)} style={{ width: '400px' }} modal closable={false} blockScroll={true} draggable={false} className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default ReporteCorteAdministrador;